import { useTranslation } from 'react-i18next';
import ModalFrame from '../../primitives/ModalFrame';


interface PlotFreeModalProps {
  isOpen: boolean;
  onBuyHouse: () => void;
  /** Зарезервовано для майбутнього онбордингу (MapCanvas передає прапорець). */
  lockForOnboarding?: boolean;
}

export default function PlotFreeModal({ isOpen, onBuyHouse }: PlotFreeModalProps) {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <ModalFrame
      isOpen={isOpen}
      onClose={() => {}} // Вимкнено закриття через onClose
      variant="dialog"
      className="max-w-[372px] rounded-xl bg-white p-0"
      hideHeader={true}
      closeOnBackdropClick={false}
    >
      <div className="relative max-h-[90vh] w-full overflow-hidden overflow-y-auto rounded-xl bg-white">
        <div
          className="plot-free-modal-content mx-auto box-border flex w-full max-w-[332px] flex-col items-center gap-xl px-2xl py-4xl max-[360px]:gap-lg max-[360px]:px-lg max-[360px]:py-xl"
        >
          {/* Заголовок та текст */}
          <div className="flex w-full flex-col items-center justify-center gap-sm text-center">
            <h2
              className="plot-free-modal-title m-0 [font-family:'Rubik_One',sans-serif] text-[18px] leading-[30px] font-normal tracking-[0px] text-text-dark max-[360px]:text-[16px] max-[360px]:leading-[24px]"
            >
              {t("This plot is free!")}
            </h2>
            <p
              className="plot-free-modal-text m-0 whitespace-pre-wrap [font-family:Lato,sans-serif] text-[16px] leading-[20px] font-normal tracking-[0px] text-text-dark max-[360px]:text-[14px] max-[360px]:leading-[18px]"
            >
              {t("You can be the first to build your dream virtual house here!")}
            </p>
          </div>

          {/* Зображення та кнопка */}
          <div className="flex w-full flex-1 flex-col items-center justify-between gap-3xl">
            {/* Зображення ділянки */}
            <div
              className="plot-free-modal-image relative aspect-square w-full max-w-[269.479px] max-[360px]:max-w-[200px]"
            >
              {/* Основне зображення */}
              <div className="relative z-[1] h-full w-full">
                <img
                  src="/ui/world-map/plot-is-free-image.png"
                  alt="Free plot"
                  className="block h-full w-full object-cover object-center"
                />
              </div>
            </div>

            {/* Кнопка Buy House */}
            <button
              className="plot-free-modal-button mt-auto box-border w-full cursor-pointer rounded-pill border-none bg-[image:var(--gradient-action-primary)] px-2xl py-lg text-center [font-family:'Rubik_One',sans-serif] text-[16px] leading-[24px] font-normal tracking-[0px] text-white shadow-action-raised [transition:all_0.2s_ease] max-[360px]:px-xl max-[360px]:py-[10px] max-[360px]:text-[14px]"
              onClick={() => {
                // Лише onBuyHouse: MapCanvas закриває PlotFreeModal і відкриває каталог.
                // Не викликати handleCloseModal тут — він скидає realEstateCatalogPlotId.
                onBuyHouse();
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.opacity = '0.9';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.opacity = '1';
              }}
            >
              {t("Choose Your House")}
            </button>
          </div>
        </div>
      </div>
    </ModalFrame>
  );
}
